import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import { Image } from '@belong/ui';

export const PaymentHeroImage = () => {
  const { width } = useWindowSize();

  const isMobile = width <= BREAKPOINTS_WIDTHS.SM;

  const src = isMobile
    ? 'improvement-reports/payment-modal-hero-mobile.jpg'
    : 'improvement-reports/payment-modal-hero.jpg';

  return (
    <Image
      alt="payment-modal-hero"
      className="
        h-[300px] rounded-t border-b border-solid border-b-dark-gray bg-cover bg-center sm:rounded-r-none sm:rounded-t
        sm:border-x-0 sm:border-b
      "
      src={src}
    />
  );
};
